import {
  EXCLUDE_FROM_CALC_TYPE,
  GET_PRICING_SUMMARY_TYPE,
  GET_PRICING_TYPE,
  GET_SUMMRYDATA,
  UPDATE_LLP_BULK_CSN_TYPE,
  UPDATE_PRICING_COLUMN_TYPE,
  UPDATE_PRICING_RP_TYPE,
  UPDATE_PRICING_TYPE,
  UPDATE_REPAIR_PERCENTAGE_PRICING_TYPE,
} from "../../../constant/asynActionsType";
import { createAppAsyncThunk } from "../../../utils/createAppAsyncThunk";
import {
  ExcludeCalcService,
  GetPricingService,
  GetPricingSummaryService,
  GetSummryDataServicePricing,
  UpdateLlpBulkCsnService,
  UpdatePricingColumnService,
  UpdatePricingService,
  UpdateRepairPercentageServicePricing,
  UpdateRPPricingService,
} from "./pricingServices";

export const getPricing = createAppAsyncThunk(
  GET_PRICING_TYPE,
  GetPricingService,
  {
    errorMessage: { show: true },
  }
);

export const getPricingSummary = createAppAsyncThunk(
  GET_PRICING_SUMMARY_TYPE,
  GetPricingSummaryService,
  {
    errorMessage: { show: true },
  }
);

export const updatePricing = createAppAsyncThunk(
  UPDATE_PRICING_TYPE,
  UpdatePricingService,

  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);

export const updatePricingRP = createAppAsyncThunk(
  UPDATE_PRICING_RP_TYPE,
  UpdateRPPricingService,

  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);

export const excludeFromCalc = createAppAsyncThunk(
  EXCLUDE_FROM_CALC_TYPE,
  ExcludeCalcService,

  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);

export const updateRepairPercentangePricing = createAppAsyncThunk(
  UPDATE_REPAIR_PERCENTAGE_PRICING_TYPE,
  UpdateRepairPercentageServicePricing,
  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);

export const getSummaryData = createAppAsyncThunk(
  GET_SUMMRYDATA,
  GetSummryDataServicePricing
);

export const updatePricingColumn = createAppAsyncThunk(
  UPDATE_PRICING_COLUMN_TYPE,
  UpdatePricingColumnService,
  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);

export const updateLlpBulkCsn = createAppAsyncThunk(
  UPDATE_LLP_BULK_CSN_TYPE,
  UpdateLlpBulkCsnService,
  {
    successMessage: { show: true },
    errorMessage: { show: true },
  }
);
